import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  let router = inject(Router)
  if ((inject(AuthService).isAuthenticated() == true)) {
    return true;
  }
  else {
    router.navigate(['/login']);
    return false;
  }
};
